import React from 'react'
import { useNavigate } from 'react-router-dom'
import { FormattedMessage } from 'react-intl'
import { FilePdfOutlined } from '@ant-design/icons'
import { UploadCloud } from 'react-feather'
import jsPDF from 'jspdf'

import { IndentedOption, SubOptionsRow } from './utils'

interface ShareDropdownProps {
  courseId: number
  exportAsPdf: () => Promise<jsPDF>
}

const ShareOption = ({ courseId, exportAsPdf }: ShareDropdownProps) => {
  const navigate = useNavigate()

  return (
    <IndentedOption>
      <SubOptionsRow onClick={() => exportAsPdf()}>
        <FilePdfOutlined style={{color: "red", marginRight: '0.5em'}}/>
        <FormattedMessage id="editor.share.exportAsPdf"/>
      </SubOptionsRow>

      <SubOptionsRow onClick={() => navigate(`/course-publish-preparation/${courseId}`)}>
        <UploadCloud size={16} style={{color: 'green', marginRight: '0.5em'}}/>
        <FormattedMessage id="generic.publish"/>
      </SubOptionsRow>
    </IndentedOption>
  )
}

export default ShareOption
